import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import { createGridRequest } from "../../hooks/useGridRequest";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";
import {
  assignmentConfig,
  assignmentColumns,
  assignmentSchema,
  mapAssignmentQuery,
  AssignmentVariant,
  AssignmentTarget,
} from "./AssignmentGridView.default";

/**
 * One grid for every assignment surface — reward|badge × company|department|user. The 6 hand-rolled
 * `*RewardsView`/`*BadgesView` clones collapsed into this single config-driven ManagedGridView wrapper.
 * Assignments are read + Delete (re-assign happens via the bulk "Assign Reward" flow on the Rewards grid).
 */
export interface AssignmentGridViewProps {
  readonly variant: AssignmentVariant;
  readonly target: AssignmentTarget;
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function AssignmentGridView(props: AssignmentGridViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);
  const variant = assignmentConfig[props.variant];
  const target = variant.targets[props.target];

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={assignmentColumns(variant, target)}
      schema={assignmentSchema(variant, target)}
      mapQuery={mapAssignmentQuery(variant, target)}
      onSearch={props.onSearch}
      request={createGridRequest(target.getFn, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can(variant.permission, "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default AssignmentGridView;
